import { FC, Props } from "./typings";
import styles from "./styles.module.scss";

const InputImitation: FC<Props> = ({ label, value }) => {
  return (
    <div className={styles.root}>
      <label>{label}</label>
      <div className={styles.root2}>
        <div
          className={styles.input}
          dangerouslySetInnerHTML={{ __html: value }}
        ></div>
      </div>
    </div>
  );
};

export default InputImitation;
